<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #recurringDepositProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="recurringDepositProductDetailsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-details-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
      >
      </LOSx-recurring-deposit-product-details-step>
    </mat-step>

    <mat-step [stepControl]="recurringDepositProductCurrencyForm">
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-currency-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
      >
      </LOSx-recurring-deposit-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="recurringDepositProductTermsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-terms-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
      >
      </LOSx-recurring-deposit-product-terms-step>
    </mat-step>

    <mat-step [stepControl]="recurringDepositProductSettingsForm">
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-settings-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
      >
      </LOSx-recurring-deposit-product-settings-step>
    </mat-step>

    <mat-step [stepControl]="recurringDepositProductInterestRateChartForm">
      <ng-template matStepLabel>{{ 'labels.inputs.INTEREST RATE CHART' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-interest-rate-chart-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
      >
      </LOSx-recurring-deposit-product-interest-rate-chart-step>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-charges-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
        [currencyCode]="recurringDepositProductCurrencyForm.get('currencyCode')"
      >
      </LOSx-recurring-deposit-product-charges-step>
    </mat-step>

    <mat-step [stepControl]="recurringDepositProductAccountingForm">
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-recurring-deposit-product-accounting-step
        [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
        [accountingRuleData]="accountingRuleData"
        [recurringDepositProductFormValid]="recurringDepositProductFormValidAndNotPrinstine"
      >
      </LOSx-recurring-deposit-product-accounting-step>
    </mat-step>

    @if (recurringDepositProductFormValidAndNotPrinstine) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-recurring-deposit-product-preview-step
          [recurringDepositProductsTemplate]="recurringDepositProductsTemplate"
          [chartSlabsDisplayedColumns]="recurringDepositProductInterestRateChartStep.chartSlabsDisplayedColumns"
          [accountingRuleData]="accountingRuleData"
          [recurringDepositProduct]="recurringDepositProduct"
          (submitEvent)="submit()"
        >
        </LOSx-recurring-deposit-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
